import React, { Dispatch, SetStateAction } from 'react';
import { TInputParams } from 'pages/common/types';
import { Rooms } from 'pages/common/components/Rooms';
import { useFilteredInputParams } from '../../forms/hooks/use-filtered-input-params';

type TProps = {
  setInputParams: Dispatch<SetStateAction<TInputParams>>;
  setActiveTabIndex: Dispatch<SetStateAction<number>>;
};
export const SavedRooms = ({ setInputParams, setActiveTabIndex }: TProps) => {
  const { defaultInputParams } = useFilteredInputParams();

  return (
    <Rooms
      setInputParams={setInputParams}
      setActiveTabIndex={setActiveTabIndex}
      defaultInputParams={defaultInputParams as TInputParams}
      isCalculator
    />
  );
};
